import './dashboard.scss';
import React from 'react';
import classnames from 'classnames';
import Card from '../card/Card';
import mock from './cards-mock.json';
import { type Playlist } from '../../api/types';

type DashboardProps = {
    overrideMediaUrl: string;
    playlists: { loading: boolean; items: Playlist[] };
};

const Dashboard = ({
    overrideMediaUrl,
    playlists,
}: DashboardProps) => (
    <div
        className={classnames('b-dashboard', {
            'is-override-bar-visible': overrideMediaUrl !== ''
        })}
    >
        {mock.cards.map((data, i) => (
            <Card
                key={i}
                data={data}
                playlists={playlists}
            />
        ))}
    </div>
);

export default Dashboard;
